/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Created/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import OneShotAction from './OneShotAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Created({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Created"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Created.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={10}
 borderBottomRightRadius={10}
 borderTopLeftRadius={10}
 borderTopRightRadius={10}
 height={16}
 width={320}
/>
</div>
<OneShotAction
  viewPath={`${viewPath}/OneShotAction`}
/>
{children}
</React.Fragment>)
}